var map = {
	"./data-search.de-CH.json": 975,
	"./data-search.de-DE.json": 976,
	"./data-search.en-CA.json": 977,
	"./data-search.en-GB.json": 978,
	"./data-search.en-IN.json": 979,
	"./data-search.en-ME.json": 980,
	"./data-search.en-US.json": 981,
	"./data-search.es-EM.json": 982,
	"./data-search.es-ES.json": 983,
	"./data-search.fr-BE.json": 984,
	"./data-search.fr-CA.json": 985,
	"./data-search.fr-CH.json": 986,
	"./data-search.nl-BE.json": 987,
	"./data-search.nl-NL.json": 988,
	"./data-search.pl-PL.json": 989,
	"./data-search.pt-BR.json": 990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;